/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import styles from '@components/DevToolbar/DevToolbarComponent/DevToolbarComponent.styles';
import Icon from '@components/icons/Icon';
import { TIcon } from '@components/icons/typescript';
type PropsType = {
  icon: TIcon;
  color: string;
  isActive: boolean;
  isSpecial?: boolean;
  onClick?: () => void;
};
const DevToolbarComponent = ({
  icon,
  color,
  isActive,
  isSpecial = false,
  onClick = () => null
}: PropsType) => <div sx={styles.component(isSpecial, isActive)} onClick={onClick}>
    <div sx={styles.componentIcon}>
      <Icon icon={icon} color={color} size="18px" />
    </div>
  </div>;
export default DevToolbarComponent;